module.exports = __webpack_public_path__ + "account/assets/image_not_found.828f6e2c.svg";